import { Flex, Separator } from '@driftt/dds'
import React from 'react'

import { StyledContent, StyledHeaderContainer } from './PageLayout.styles'

interface Props {
  sideNav: React.ReactNode
  header: React.ReactNode
  children?: React.ReactNode
  overflow?: boolean
}

const PageLayout = ({ sideNav, header, overflow, children }: Props) => {
  return (
    <Flex direction="row" fullWidth fullHeight gap={0}>
      {sideNav}
      <Flex direction="column" gap={0} fullWidth fullHeight>
        <StyledHeaderContainer fullWidth>{header}</StyledHeaderContainer>
        <Separator />
        <StyledContent fullWidth grow={1} overflow={overflow}>
          {children}
        </StyledContent>
      </Flex>
    </Flex>
  )
}

export default PageLayout
